
import { Vue } from "vue-class-component";

export default class CopyClipboard extends Vue {}
